import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { callSalesforceApi, callTokenApi } from '../../../../apiCaller';
import { API_CLIENT_REPORTING_UTM_LIST, API_SALESFORCE_LIST_FIELDS_CUSTOM_OBJECT, DEFAULT_DATE_FORMAT, DEFAULT_OBJECT_SF, REPORT_NAMES, REPORT_TYPE } from '../../../../constants';
import { formatTableName } from '../../../../utils';
const mergeObjects = (obj1, obj2) => {
     const mergeArrayByKey = (arr1 = [], arr2 = []) => {
          const map = new Map();
          [...arr1, ...arr2].forEach(item => {
               if (!map.has(item.key)) {
                    map.set(item.key, item);
               }
          });
          return Array.from(map.values());
     };

     return {
          dimensions: mergeArrayByKey(obj1.dimensions, obj2.dimensions),
          properties: mergeArrayByKey(obj1.properties, obj2.properties),
          metrics: mergeArrayByKey(obj1.metrics, obj2.metrics)
     };
}
const useUtmArray = (props) => {
     const { setUtmArray,listDynamicFields, setListDynamicFields, dimensions, reportName, reportType, customObjectSF, SFObject, objectID } = props;
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const dateRangeReports = useSelector((state) => state.subscriber.dateRangeReports);
     const externalObjectReport = useSelector((state) => state.subscriber.externalObjectReport);
     const customExternalObjectReport = useSelector((state) => state.subscriber.customExternalObjectReport);
     const [utmLoading, setUtmLoading] = useState(false);
     const newDateRange = {
          selection: {
               startDate: dateRangeReports.selection?.startDate.format(DEFAULT_DATE_FORMAT),
               endDate: dateRangeReports.selection?.endDate.format(DEFAULT_DATE_FORMAT),
          },
     };
     const bodyData = {
          accountId: activeAccount.id,
          dateRangeReports: newDateRange,
          dimensions,
          reportName,
          object: SFObject,
          isCustom: !!customObjectSF
     };
     const fetchData = () => {
          if ([REPORT_TYPE.SALE_FORCE].includes(reportType) && newDateRange?.selection?.startDate) {
               setUtmLoading(true);
               const customTable = externalObjectReport.filter((e) => !DEFAULT_OBJECT_SF[e.object] && e.object !== customObjectSF).map((e) => `CRM${e.object}` );
               bodyData.customTable = customTable;

               callSalesforceApi(API_SALESFORCE_LIST_FIELDS_CUSTOM_OBJECT, "POST", bodyData)
                    .then((response) => {
                         if (response?.status === 200) {
                              bodyData.otherFields = response.data?.columns
                         }
                    })
                    .finally(() => {
                         callTokenApi(API_CLIENT_REPORTING_UTM_LIST, 'POST', bodyData)
                              .then((response) => {
                                   if (response?.status === 200) {
                                        const listDynamicFieldsNew = response.data.listDynamicFields;
                                        setListDynamicFields(mergeObjects(listDynamicFields, listDynamicFieldsNew));
                                   }
                              })
                              .finally(() => {
                                   setUtmLoading(false);
                              });
                    });

          }

          if ([REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT, REPORT_NAMES.CUSTOM_EXTERNAL_OBJECT].includes(reportName) && newDateRange?.selection?.startDate) {
               setUtmLoading(true);
               const externalObject = customExternalObjectReport?.length > 0 ? customExternalObjectReport.find((item) => item?.id === objectID) : [];
               if(customExternalObjectReport?.length > 0 && externalObject?.otherFields?.length > 0) {
                    const customTable = customExternalObjectReport.filter((e) => e?.object !== SFObject && e?.externalId === externalObject.externalId).map((e) => `${formatTableName({ name: e?.object, prefix: '', isObject: true })}` );
                    bodyData.customTable = customTable;
                    bodyData.otherFields = externalObject?.otherFields[0].fields;
               }
               callTokenApi(API_CLIENT_REPORTING_UTM_LIST, 'POST', bodyData)
                    .then((response) => {
                         if (response?.status === 200) {
                              if(REPORT_NAMES.CUSTOM_EXTERNAL_OBJECT === reportName){
                                   const listDynamicFieldsNew = response.data.listDynamicFields;
                                   setListDynamicFields(mergeObjects(listDynamicFields, listDynamicFieldsNew));
                              } else {
                                   const utmList = response.data.utmList;
                                   setUtmArray(utmList);
                              }

                         }
                    })
                    .finally(() => {
                         setUtmLoading(false);
                    });
          }
     };

     useEffect(fetchData, [JSON.stringify(dateRangeReports)]); // eslint-disable-line react-hooks/exhaustive-deps

     return utmLoading;
};

export default useUtmArray;
